import { type RegisteredRouter, RouterProvider } from "@tanstack/react-router"
import { useSelector } from "@tanstack/react-store"
import { useLayoutEffect } from "react"
import { UpdateRequiredScreen } from "@/app/ui"
import { useUpdateRequired } from "@/shared/lib/app-update/update-required"
import {
	type Platform,
	PlatformProvider,
	type StoreId,
	triggerImpact,
} from "@/shared/lib/platform"
import { markSplashSeen, removeSplash } from "../splash"
import { bootStore } from "../store"

// The splash comes from index.html and paints before any JS. It is dropped in a
// layout effect after the first screen commits, so there is no empty frame.
export function App({
	router,
	platform,
	store,
}: {
	router: RegisteredRouter
	platform: Platform
	store: StoreId | null
}) {
	const isReady = useSelector(bootStore, (state) => state.phase === "ready")
	const isUpdateRequired = useUpdateRequired()

	useLayoutEffect(() => {
		if (!isReady) return
		removeSplash()
		markSplashSeen()
		triggerImpact("heavy")
	}, [isReady])

	if (!isReady) return null

	if (isUpdateRequired) return <UpdateRequiredScreen />

	return (
		<PlatformProvider platform={platform} store={store}>
			<RouterProvider router={router} />
		</PlatformProvider>
	)
}
